import { useEffect, useRef } from 'react';

let seq = 0;

/**
 * While mounted, the browser back button (and the Android back gesture) calls `onBack`
 * instead of leaving the app. Used by sheets and the other-hunter profile screen.
 */
export function useBackLayer(onBack: () => void) {
  const cb = useRef(onBack);
  cb.current = onBack;

  useEffect(() => {
    const id = ++seq;
    window.history.pushState({ ...(window.history.state as object | null), ethrLayer: id }, '');
    let popped = false;
    const onPop = () => {
      popped = true;
      cb.current();
    };
    window.addEventListener('popstate', onPop);
    return () => {
      window.removeEventListener('popstate', onPop);
      // Closed some other way (a button): drop the history entry we added.
      if (!popped && (window.history.state as { ethrLayer?: number } | null)?.ethrLayer === id) window.history.back();
    };
  }, []);
}
